import { createContext, useContext } from 'react'

import { ImportedListingsContextValue } from './imported-listings-context-types'

const ImportedListingsContext =
  createContext<ImportedListingsContextValue | null>(null)

/**
 * Reads the current imported-listings state. Throws if used outside
 * ImportedListingsProvider.
 *
 * @returns {ImportedListingsContextValue}
 */
const useImportedListings = (): ImportedListingsContextValue => {
  const context = useContext(ImportedListingsContext)

  if (context === null) {
    throw new Error(
      'useImportedListings must be used within an ImportedListingsProvider',
    )
  }

  return context
}

export { ImportedListingsContext, useImportedListings }
